<template>
  <div class="general-info department-gallery-block">
    <div class="general-info__container">
      <div v-if="heading" class="general-info__title">
        <h1 class="text-TTDrugs-Bold-40 color-green center text-uppercase">{{ heading }}</h1>
      </div>
      <div v-if="swiperSlides.length" class="general-info__index-mg">
        <AppSwiperDepartments :list_image="swiperSlides" />
      </div>
    </div>
  </div>
</template>

<script>
import AppSwiperDepartments from '@/components/Gallery/SwiperDepartments.vue'

export default {
  name: 'AppDepartmentGalleryBlock',
  components: { AppSwiperDepartments },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    heading() {
      return (this.data && this.data.heading) || ''
    },
    swiperSlides() {
      const raw = (this.data && this.data.slides) || []
      if (!Array.isArray(raw)) return []
      return raw
        .map((s, idx) => ({
          id: idx + 1,
          image: s && s.image ? String(s.image).trim() : '',
        }))
        .filter((s) => s.image)
    },
  },
}
</script>

<style scoped>
</style>
